import { useMutation, useQueryClient } from "@tanstack/react-query";
import UserMedal from "../interfaces/userMedal";
import { USER_MEDALS_URL } from "../util/constants";
import useApi from "./useApi";

const useRegisterUserMedal = (token: string) => {
    const { register } = useApi<UserMedal[]>(`${USER_MEDALS_URL}/${token}`);

    const query = useQueryClient();

    return useMutation({
        mutationFn: (userMedals: UserMedal[]) => register(userMedals),
        onSuccess: () => {
            query.invalidateQueries({queryKey: ["userMedal", token]});
        }
    })
};

export default useRegisterUserMedal;